const Data = [
    {
        name: "Rehana Tehazeen",
        position: "Media & Publicity Team",
        imageUrl: "/assets/images/members/RehanaTehazeen.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Tanushri Tawari",
        position: "Media & Publicity Team",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
]

export default Data;